export default __webpack_public_path__ + "static/media/u3.6ef14824.svg";